import { site } from "@/data/siteContent";

export default function WhatsAppButton() {
  const number = (site.contact.whatsapp || "").replace(/[^0-9]/g, "");
  const href = `https://wa.me/${number || ""}?text=${encodeURIComponent(
    "Namaste Jyotish ji, I would like to book a consultation.",
  )}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-20 right-5 sm:bottom-6 sm:right-6 z-50 group"
    >
      <span className="animate-pulse-gold flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] text-white shadow-2xl ring-2 ring-[#D4AF37]/50 hover:scale-105 transition-transform duration-300">
        {/* WhatsApp glyph */}
        <svg
          viewBox="0 0 32 32"
          className="w-7 h-7 sm:w-8 sm:h-8 fill-current"
          aria-hidden="true"
        >
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.638 3.483 4.65 4.4.616.287 2.152.888 2.853.888.717 0 2.166-.933 2.166-1.804 0-.115-.028-.14-.043-.195-.115-.244-2.32-1.061-2.336-1.075zM16.257 3.588a11.994 11.994 0 0 0-10.29 18.14L4 30l8.446-2.212a11.99 11.99 0 0 0 3.816.626h.006c6.612 0 12-5.383 12-11.997A11.996 11.996 0 0 0 16.257 3.588zm7.11 19.106a9.995 9.995 0 0 1-7.093 2.94 9.958 9.958 0 0 1-3.647-.685l-.505-.183-5.24 1.373 1.402-5.05-.203-.518a9.914 9.914 0 0 1-.7-3.652c0-5.5 4.487-9.983 10.007-9.983 5.507 0 9.988 4.483 9.988 9.983.001 5.516-4.507 9.998-9.988 9.998" />
        </svg>
      </span>
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap glass px-3 py-2 rounded-full text-[11px] tracking-[0.2em] uppercase text-gold opacity-0 group-hover:opacity-100 transition-opacity duration-300 hidden sm:inline-block">
        Chat on WhatsApp
      </span>
    </a>
  );
}
